<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button v-if="resource.idEstatusSolicitud != 3 && resource.idEstatusSolicitud != 4"
      @click="putCambiarEstatusSolicitud(data.item.idSolicitudDiagnostico, resource.idEstatusSolicitud)"
      variant="outline-warning"
      >Cambiar a estatus Incompletos</b-button>
  </div>
</template>

<script>
export default {
  name: "BandejaCambiarEstatusIncompletosComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    putCambiarEstatusSolicitud(idSolicitudDiagnostico, idEstatusSolicitud) {
      var params = {
        idSolicitudDiagnostico: idSolicitudDiagnostico,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
        idEstatus : 6
      };

      this.$http
        .put(
          this.$api +
            "hallazgo/bandeja/cdx/actualizarestatussolicitud",
          params
          
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => (this.funcionExtraBandeja(idEstatusSolicitud)));
    },
    funcionExtraBandeja(idEstatusSolicitud) {
      this.$emit("_funcionExtra", idEstatusSolicitud);
    },
  },
};
</script>
